import React, { useMemo } from 'react';

import { SECTIONS } from 'components/Globals/Analytics/constants';

import { TP } from 'constants/index';

import useNavigate from 'utils/hooks/useNavigate';
import { useQuery } from 'utils/react-query';

import queries from 'containers/Globals/queries';

import { useTranslation } from 'src/i18n';

import { ENTITY_TYPES, ROUTE_RESERVED_KEYWORDS } from 'operabase-router/constants';

import EntitySectionFilters from '../Common/EntitySectionFilters';
import EntitySwimLane from '../Common/EntitySwimLane';
import FeaturedEntitySection from '../Common/FeaturedEntitySection';

import classes from './FeaturedComposers.module.scss';

const trackingData = {
  section: SECTIONS.FEATURED_COMPOSERS,
};

const FeaturedComposers = ({ limit = 5 }) => {
  const { t } = useTranslation('NS_APP_GLOBALS');
  const navigate = useNavigate();
  const linkProps = useMemo(() => navigate.getLinkProps({ basePath: ROUTE_RESERVED_KEYWORDS.composers }), [navigate]);

  const { data } = useQuery(
    queries.getHomepageFeaturedComposers({
      filters: {
        is_pro: true,
        enable_serendipity: true,
      },
      limit,
      queryConfig: {
        select: response => response?.slice(0, limit),
      },
    }),
  );

  return (
    <FeaturedEntitySection title={t(`${TP}.m_COMPOSERS`)} linkProps={linkProps} trackingData={trackingData}>
      <div className={classes.filters}>
        <EntitySectionFilters
          allowedEntityTypes={[ENTITY_TYPES.PROFILE, ENTITY_TYPES.ORGANIZATION]}
          trackingData={trackingData}
          skipSearchCollapse
          isComposer
        />
      </div>
      <EntitySwimLane data={data} trackingData={trackingData} />
    </FeaturedEntitySection>
  );
};

export default FeaturedComposers;
